import { useKas } from "contexts/KasContext";
import React, { useEffect, useState } from "react";
import {
  SettingsSection,
  SettingsSectionContent,
  SettingsSectionHeader,
  SettingsSectionItem,
  SettingsSectionItems,
} from "components/Graphs/SettingsSection";

const CLI_INSTALL_CMD = "brew install brevdev/homebrew-brev/brev";

const CLI = () => {
  const [CLI_LOGIN_CMD, setCLI_LOGIN_CMD] = useState("brev login");
  const { starfleetIdToken } = useKas(); // Add this line to get the KAS context

  useEffect(() => {
    setCLI_LOGIN_CMD(`brev login --token ${starfleetIdToken}`);
  }, [starfleetIdToken]);

  return (
    <div>
      {/* ITEM */}
      <SettingsSection>
        <SettingsSectionHeader
          title="Install CLI"
          description="Install the Brev CLI to your system"
        />
        <SettingsSectionContent>
          <SettingsSectionItems>
            <SettingsSectionItem
              label="Install CLI"
              value={CLI_INSTALL_CMD}
              showCopyButton
            />
            <SettingsSectionItem
              label="Login via CLI (paste this in your terminal)"
              displayValue="brev login --token *****"
              value={CLI_LOGIN_CMD}
              showCopyButton
            />
          </SettingsSectionItems>
        </SettingsSectionContent>
      </SettingsSection>
    </div>
  );
};

export default CLI;
